import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect
} from 'react-router-dom'
import { useState, useContext } from 'react'
import HeaderLayout from './Header'

import ProductionOrders from '../pages/ProductionOrder'
import ProductionOrderConfirm from '../pages/ProductionOrderConfirm'
import ProductionProcess from '../pages/Form/ProductionProcess'
import ProductionProcessConfirm from '../pages/Form/ProductionProcessConfirm'
import Home from '../pages/Home'
import Master from '../pages/Masters'
import Users from '../pages/Users'
import Report from '../pages/Report'

import PicklistApprove from '../pages/PicklistApprove/index'
import PicklistApproveDetail from '../pages/PicklistApprove/detail'
import PicklistCheck from '../pages/PicklistCheck/index'
import PicklistCheckDetail from '../pages/PicklistCheck/detail'
import PicklistCheckDetailExtra from '../pages/PicklistCheck/extra'
import PicklistQaCheck from '../pages/PicklistQaCheck/index'
import PicklistQaCheckDetail from '../pages/PicklistQaCheck/detail'
import PicklistQaCheckDetailExtra from '../pages/PicklistQaCheck/extra'
import PicklistComplete from '../pages/PicklistComplete/index'
import PicklistCompleteDetail from '../pages/PicklistComplete/detail'
import PicklistReturn from '../pages/PicklistReturn/index'
import PicklistReturnDetail from '../pages/PicklistReturn/detail'
import PicklistExtra from '../pages/PicklistExtra'
import WasteReturnPicklist from '../pages/WasteReturnPicklist'
import GoodIssueOrder from '../pages/GoodIssueOrder/index'
import GoodIssueOrderDetail from '../pages/GoodIssueOrder/detail'
import GoodIssueOrderExtra from '../pages/GoodIssueOrder/extra'

import UnAuthorizedPage from '../components/UnAuthorizedPage'

import { NavMenus } from '../constants/Enum'
import { OrderType } from '../constants/EnumType';

import OrderContext from '../contexts/OrderContext'
import UserContext from '../contexts/UserContext'

import { sub } from 'date-fns'
import PicklistDetail from '../pages/PicklistDetail'
import BulkInspectionApprove from '../pages/BulkInspectionApprove'
import OrderClaim from '../pages/OrderClaim'
import FGInspectionPage from '../pages/FGInspectionPage'

import { Permission } from '../constants/Permission';
import OrderReceiptApproval from '../pages/OrderReceiptApproval/index'
import OrderReceiptApprovalDetail from '../pages/OrderReceiptApproval/detail'
import GoodReverseOrderDetail from '../pages/GoodReverseOrder/detail'

function RouterLayout() {

  const [order, setOrder] = useState(null);
  const value = { order, setOrder };
  const { user, readOnly } = useContext(UserContext)
  const fromDate = sub(new Date(), { days: 7 })
  const toDate = new Date()

  const isAuthorizedPage = (user, path) => {
    const permissions = Permission[user.department][user.line || OrderType.All][user.role.toUpperCase()]
    const countOfMatchPermission = permissions.reduce((prev, cur) => prev + (path.includes(cur)), 0)
    return countOfMatchPermission > 0
  }

  return (
    <Router>
      <HeaderLayout />
      <Switch>
        <Route exact path="/" component={Home} />
        <Route path="/unauthorized" component={UnAuthorizedPage} />
        <AuthorizedRoute exact path="/order-ready">
          <ProductionOrders />
        </AuthorizedRoute>
        <AuthorizedRoute exact path="/order-wait-confirm">
          <ProductionOrderConfirm />
        </AuthorizedRoute>
        <AuthorizedRoute exact path="/master">
          <Master />
        </AuthorizedRoute>
        <AuthorizedRoute exact path="/order-ready/:id">
          <OrderContext.Provider value={value}>
            <ProductionProcess />
          </OrderContext.Provider>
        </AuthorizedRoute>
        <AuthorizedRoute exact path="/order-wait-confirm/:id">
          <OrderContext.Provider value={value}>
            <ProductionProcessConfirm />
          </OrderContext.Provider>
        </AuthorizedRoute>
        <Route
          exact path="/picklist-approve"
          render={(props) => isAuthorizedPage(user, '/picklist-approve') ? <PicklistApprove {...props} title={getTitle('picklist-approve')}
            division={user?.division || ''} line={user?.line || ''}
            from={fromDate} to={toDate} /> : <Redirect to={{ pathname: "/unauthorized" }}/>} />
        <Route 
          exact path="/picklist-approve/:id"
          render={(props) => isAuthorizedPage(user, '/picklist-approve') ? <PicklistApproveDetail {...props} title={getTitle('picklist-approve')}
            id={props.match.params.id}
            username={user?.name || user?.givenName || user?.username || ''}
            readOnly={readOnly}/> : <Redirect to={{ pathname: "/unauthorized" }}/>} />
        <Route 
          exact path="/picklist-check"
          render={(props) => isAuthorizedPage(user, '/picklist-check') ? <PicklistCheck {...props} title={getTitle('picklist-check')}
            line={user?.line || ''} division={user?.division || ''}
            from={fromDate} to={toDate}
            username={user?.name || user?.givenName || user?.username || ''}
            readOnly={readOnly} /> : <Redirect to={{ pathname: "/unauthorized" }}/>} />
        <Route 
          exact path="/picklist-check/:id"
          render={(props) => isAuthorizedPage(user, '/picklist-check') ? <PicklistCheckDetail {...props} title={getTitle('picklist-check')}
            id={props.match.params.id}
            username={user?.name || user?.givenName || user?.username || ''}
            readOnly={readOnly} /> : <Redirect to={{ pathname: "/unauthorized" }}/>} />
        <Route 
          exact path="/picklist-check/:id/extra/:extraId"
          render={(props) => isAuthorizedPage(user, '/picklist-check') ? <PicklistCheckDetailExtra {...props} title={getTitle('picklist-check')}
            id={props.match.params.id}
            extraId={props.match.params.extraId}
            username={user?.name || user?.givenName || user?.username || ''}
            readOnly={readOnly} /> : <Redirect to={{ pathname: "/unauthorized" }}/>} />
        <Route 
          exact path="/picklist-qa-check"
          render={(props) => isAuthorizedPage(user, '/picklist-qa-check') ? <PicklistQaCheck {...props} title={getTitle('picklist-qa-check')}
            line={user?.line || ''} division={user?.division || ''}
            from={fromDate} to={toDate}
            username={user?.name || user?.givenName || user?.username || ''}
            readOnly={readOnly} /> : <Redirect to={{ pathname: "/unauthorized" }}/>} />
        <Route 
          exact path="/picklist-qa-check/:id"
          render={(props) => isAuthorizedPage(user, '/picklist-qa-check') ? <PicklistQaCheckDetail {...props} title={getTitle('picklist-qa-check')}
            id={props.match.params.id}
            username={user?.name || user?.givenName || user?.username || ''}
            readOnly={readOnly} /> : <Redirect to={{ pathname: "/unauthorized" }}/>} />
        <Route 
          exact path="/picklist-qa-check/:id/extra/:extraId"
          render={(props) => isAuthorizedPage(user, '/picklist-qa-check') ? <PicklistQaCheckDetailExtra {...props} title={getTitle('picklist-qa-check')}
            id={props.match.params.id}
            extraId={props.match.params.extraId}
            username={user?.name || user?.givenName || user?.username || ''}
            readOnly={readOnly} /> : <Redirect to={{ pathname: "/unauthorized" }}/>} />
        <Route 
          exact path="/picklist-complete"
          render={(props) => isAuthorizedPage(user, '/picklist-complete') ? <PicklistComplete {...props} title={getTitle('picklist-complete')}
            division={user?.division || ''} line={user?.line || ''}
            from={fromDate} to={toDate}/> : <Redirect to={{ pathname: "/unauthorized" }}/>} />
        <Route 
          exact path="/picklist-complete/:id"
          render={(props) => isAuthorizedPage(user, '/picklist-complete') ? <PicklistCompleteDetail {...props} title={getTitle('picklist-complete')}
            id={props.match.params.id}
            username={user?.name || user?.givenName || user?.username || ''}
            department={user?.department || ''}
            readOnly={readOnly}/> : <Redirect to={{ pathname: "/unauthorized" }}/>} />
        <Route 
          exact path="/picklist-return"
          render={(props) => isAuthorizedPage(user, '/picklist-return') ? <PicklistReturn {...props} title={getTitle('picklist-return')}
            division={user?.division || ''} from={fromDate} to={toDate}/> : <Redirect to={{ pathname: "/unauthorized" }}/>} />
        <Route 
          exact path="/picklist-return/:id"
          render={(props) => isAuthorizedPage(user, '/picklist-return') ? <PicklistReturnDetail {...props} title={getTitle('picklist-return')}
            id={props.match.params.id}
            username={user?.name || user?.givenName || user?.username || ''}
            readOnly={readOnly} /> : <Redirect to={{ pathname: "/unauthorized" }}/>} />
        <Route
          exact path="/picklist-extra"
          render={(props) => isAuthorizedPage(user, '/picklist-extra') ? <PicklistExtra {...props} title={getTitle('picklist-extra')}
          division={user?.division || ''}
          from={fromDate} to={toDate} line={user?.line || ''}
          username={user?.name || user?.givenName || user?.username || ''}
          readOnly={readOnly} /> : <Redirect to={{ pathname: "/unauthorized" }}/>} />
        <Route exact path='/users'
          render={props => user.group === 'Admins' ? <Users {...props} division={user?.division || ''} line={user?.line || ''} department={user?.department || ''}/> : <Redirect to={{ pathname: "/unauthorized" }}/> }
        />
        <Route
          exact path="/report"
          render={(props) => isAuthorizedPage(user, '/report') ?
            <Report /> : 
            <Redirect to={{ pathname: "/unauthorized" }}/>
          }
        />
        <Route
          exact path="/waste-return"
          render={(props) => isAuthorizedPage(user, '/waste-return') ? <WasteReturnPicklist {...props} title={getTitle('waste-return')}
          division={user?.division || ''}
          from={fromDate} to={toDate} line={user?.line || ''}
          username={user?.name || user?.givenName || user?.username || ''}
          readOnly={readOnly} /> : <Redirect to={{ pathname: "/unauthorized" }}/>} />
        <Route
          exact path="/bulk-inspection"
          render={(props) => isAuthorizedPage(user, '/bulk-inspection') ? <BulkInspectionApprove {...props} title={getTitle('bulk-inspection')}
          division={user?.division || ''}
          from={fromDate} to={toDate} line={user?.line || ''}
          username={user?.name || user?.givenName || user?.username || ''}
          readOnly={readOnly} /> : <Redirect to={{ pathname: "/unauthorized" }}/>}
        />
        <Route
          exact path="/picklist-detail"
          render={(props) => isAuthorizedPage(user, '/picklist-detail') ?
            <PicklistDetail /> : 
            <Redirect to={{ pathname: "/unauthorized" }}/>
          }
        />
        <Route 
          exact path="/good-issue-order/:type"
          render={(props) => isAuthorizedPage(user, '/good-issue-order') ? <GoodIssueOrder {...props} title={getTitle(`good-issue-order/${props.match.params.type}`)}
            division={user?.division || ''}
            from={fromDate}
            to={toDate}
            orderType={props.match.params.type}
          /> : <Redirect to={{ pathname: "/unauthorized" }}/>} />
        <Route 
          exact path="/good-issue-order/:type/:id"
          render={(props) => isAuthorizedPage(user, '/good-issue-order') ? <GoodIssueOrderDetail {...props} title={getTitle(`good-issue-order/${props.match.params.type}`)}
            orderType={props.match.params.type}
            id={props.match.params.id}
            username={user?.name || user?.givenName || user?.username || ''}
            readOnly={readOnly} /> : <Redirect to={{ pathname: "/unauthorized" }}/>} />
        <Route 
          exact path="/good-issue-order/:type/:id/extra/:extraId"
          render={(props) => isAuthorizedPage(user, '/good-issue-order') ? <GoodIssueOrderExtra {...props} title={getTitle(`good-issue-order/${props.match.params.type}`)}
            id={props.match.params.id}
            extraId={props.match.params.extraId}
            orderType={props.match.params.type}
            username={user?.name || user?.givenName || user?.username || ''}
            readOnly={readOnly}/> : <Redirect to={{ pathname: "/unauthorized" }}/>} />
        <Route 
          exact path="/order-claim"
          render={(props) => isAuthorizedPage(user, '/order-claim') ? <OrderClaim {...props} title={getTitle(`order-claim`)}
            from={fromDate}
            to={toDate}
          /> : <Redirect to={{ pathname: "/unauthorized" }}/>} />
        <Route
          exact path="/fg-inspection"
          render={(props) => isAuthorizedPage(user, '/fg-inspection') ? <FGInspectionPage {...props} title={getTitle('fg-inspection')}
          username={user?.name || user?.givenName || user?.username || ''}
          readOnly={readOnly} /> : <Redirect to={{ pathname: "/unauthorized" }}/>}
        />
        <Route
          exact path="/order-receipt-approval"
          render={(props) => isAuthorizedPage(user, '/order-receipt-approval') ? <OrderReceiptApproval {...props} title={getTitle('order-receipt-approval')}
          username={user?.name || user?.givenName || user?.username || ''}
          department={user?.department || ''}
          from={fromDate}
          to={toDate}
          readOnly={readOnly} /> : <Redirect to={{ pathname: "/unauthorized" }}/>}
        />
        <Route 
          exact path="/order-receipt-approval/:id"
          render={(props) => isAuthorizedPage(user, '/order-receipt-approval') ? <OrderReceiptApprovalDetail {...props} title={getTitle('order-receipt-approval')}
            id={props.match.params.id}
            username={user?.name || user?.givenName || user?.username || ''}
            readOnly={readOnly}
            department={user?.department || ''} /> : <Redirect to={{ pathname: "/unauthorized" }}/>} />
        <Route 
          exact path="/good-reverse-order/:type/:id"
          render={(props) => isAuthorizedPage(user, '/good-reverse-order') ? <GoodReverseOrderDetail {...props}
          title={getTitle(`good-reverse-order/${props.match.params.type}`)}
            orderType={props.match.params.type}
            id={props.match.params.id}
            username={user?.name || user?.givenName || user?.username || ''}
            readOnly={readOnly} /> : <Redirect to={{ pathname: "/unauthorized" }}/>} />
      </Switch>
    </Router>
  );
}

const getTitle = (path) => {
  return NavMenus.find(m => m.path === path).title || ''
}

const AuthorizedRoute = ({ children, ...rest }) => {
  const { user } = useContext(UserContext)
  
  const isAuthorizedPage = (user, path) => {
    const permissions = Permission[user.department][user.line || OrderType.All][user.role.toUpperCase()]
    const countOfMatchPermission = permissions.reduce((prev, cur) => prev + (path.includes(cur)), 0)
    return countOfMatchPermission > 0
  }

  return (
    <Route
      {...rest}
      render={() =>
        isAuthorizedPage(user, rest.path) ? ( children ) : (
          <Redirect to={{ pathname: "/unauthorized" }}/>
        )
      }
    />
  );
}

export default RouterLayout;
